export type VelaApprovalKind = 'urgent' | 'good' | 'warn';

export type VelaApproval = {
  id: string;
  kind: VelaApprovalKind;
  tag: string;
  shortTag: string;
  title: string;
  btnLabel: string;
  reviewHref: string;
  skipLabel?: string;
  hint: string;
};

export type VelaDoneItem = {
  id: string;
  tag: string;
  title: string;
  meta: string;
};

// Hardcoded for now; wire to real activity + approval APIs later.
export const VELA_APPROVALS: ReadonlyArray<VelaApproval> = [
  {
    id: 'overdue-reminders',
    kind: 'urgent',
    tag: 'Overdue, now',
    shortTag: 'overdue chase',
    title: 'I drafted 13 reminder emails for $3,937 in overdue invoices. Longest: Alberta Health Services, 61 days.',
    btnLabel: 'Review drafts',
    reviewHref: '/invoices?filter=overdue',
    skipLabel: 'Dismiss all',
    hint: 'You preview each email and send; nothing goes out from here.',
  },
  {
    id: 'payroll-draft',
    kind: 'good',
    tag: 'Payroll, due 14 Oct',
    shortTag: 'payroll draft',
    title: 'Oct 1-15 draft is ready: $14,284 for 8 employees. All timesheets approved.',
    btnLabel: 'Review run',
    reviewHref: '/payroll/overview',
    skipLabel: 'Open draft',
    hint: 'Opens full breakdown by employee; approval and send live on the run page.',
  },
  {
    id: 'idle-cash-transfer',
    kind: 'warn',
    tag: 'Idle cash, 14 days',
    shortTag: 'cash transfer',
    title: 'Cash above threshold. I drafted a $1,000 transfer to high-interest savings.',
    btnLabel: 'Preview transfer',
    reviewHref: '/payroll/bank-accounts',
    skipLabel: 'Dismiss',
    hint: 'Shows source and destination account and amount; you confirm there.',
  },
];

export const VELA_ACTIVITY = {
  thingsDone: 7,
  summary: 'Chased 11 late payers, matched 24 bank lines, reconciled Oct payroll draft, flagged 2 duplicate charges.',
};

export const VELA_DONE_THIS_WEEK: ReadonlyArray<VelaDoneItem> = [
  {
    id: 'done-recon',
    tag: 'Done, reconciled',
    title: 'Matched 24 bank lines to invoices (RBC chequing). 2 flagged as duplicate charges, held for your review.',
    meta: 'This morning',
  },
  {
    id: 'done-chased',
    tag: 'Done, chased',
    title: 'Sent 11 payment reminders (you approved yesterday). 3 clients opened, 1 paid: Mrs Wannechko $312.',
    meta: 'Yesterday',
  },
];
